// Import React and the Container component from Material-UI
import React from 'react';
import { Container } from '@mui/material';

// components/layout.js
const CustomContainer = ({ children }) => {
  return <Container maxWidth="xl">{children}</Container>;
};

export default CustomContainer;
